module.exports = __webpack_public_path__ + "img/2.a8ac08bb.png";